import toKebabCase from 'PlugAndPlay/_global/js/stringToKebab';

export default function _inPageNavigation() {
    const inPageNavigationContainer = document.querySelector(
        '.in-page-navigation'
    );

    let headerInPageNavLevel;

    if (inPageNavigationContainer) {
        headerInPageNavLevel = inPageNavigationContainer.dataset.heading;
    }

    const navigationList = document.querySelector(
        '.in-page-navigation__container__list'
    );

    const navagationContentsContainer = document.querySelector('.content');

    const headings = navagationContentsContainer
        ? navagationContentsContainer.querySelectorAll(headerInPageNavLevel)
        : document.querySelectorAll(headerInPageNavLevel);

    if (headings.length !== 0) {
        inPageNavigationContainer.classList.add('is-visible');
    }

    // eslint-disable-next-line no-cond-assign, no-param-reassign
    headings.forEach((item, i) => {
        const headingId = toKebabCase(item.innerText);

        item.setAttribute('id', headingId);

        navigationList.innerHTML += `<li>
                                            <svg class="svg-icon in-nav-icon">
                                                <use href="#chevron"></use>
                                            </svg>
                                            <a href="#${headingId}" class="anchor-link">
                                                <span class='navigation-item'>${item.innerText}</span>
                                            </a>
                                        </li>`;
    });
}

_inPageNavigation();
